var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_1709_19768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9717 6.38308V23.562H6.79275V6.38308H23.9717ZM23.9717 3.92896H6.79275C5.44298 3.92896 4.33862 5.03331 4.33862 6.38308V23.562C4.33862 24.9118 5.44298 26.0161 6.79275 26.0161H23.9717C25.3214 26.0161 26.4258 24.9118 26.4258 23.562V6.38308C26.4258 5.03331 25.3214 3.92896 23.9717 3.92896ZM18.0081 14.8007L14.3269 19.5495L11.701 16.3714L8.01982 21.1079H22.7446L18.0081 14.8007Z",
    fill: "#354052"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1709_19768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.4495,
    height: 29.4495,
    fill: "white",
    transform: "translate(0.657471 0.247803)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.44bc6a8851fe137582ea9f5c67043419.svg";
export { ForwardRef as ReactComponent };